import { OTHER_IMPOUND_CATEGORY_LABEL } from './LoanActionImpoundRow.constants';

export const getImpoundTypeGroupLabel = ({ categoryName }) =>
  categoryName ?? OTHER_IMPOUND_CATEGORY_LABEL;
